// Back to Top Button Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Create back to top button
  const backToTopButton = document.createElement('button');
  backToTopButton.className = 'back-to-top';
  backToTopButton.setAttribute('aria-label', 'Back to top');
  
  // Add SVG icon
  backToTopButton.innerHTML = `
    <svg class="svg-icon" viewBox="0 0 384 512">
      <path d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
    </svg>
  `;
  
  // Add to body
  document.body.appendChild(backToTopButton);
  
  // Show/hide button based on scroll position
  function toggleBackToTop() {
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    if (scrollY > 200) {
      backToTopButton.classList.add('show');
    } else {
      backToTopButton.classList.remove('show');
    }
  }
  
  // Scroll to top function
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  
  // Event listeners
  window.addEventListener('scroll', toggleBackToTop, { passive: true });
  window.addEventListener('touchmove', toggleBackToTop, { passive: true });
  backToTopButton.addEventListener('click', scrollToTop);
  backToTopButton.addEventListener('touchend', function(e) {
    e.preventDefault();
    scrollToTop();
  });
  
  // Initial check
  toggleBackToTop();
  
  // Force show on mobile after a delay
  setTimeout(() => {
    if (window.innerWidth <= 768) {
      const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY > 100) {
        backToTopButton.classList.add('show');
      }
    }
  }, 1000);
});
